import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/play-circle.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM10.0273 6.91699C10.3329 6.92687 10.5784 7.04163 10.7217 7.11621C10.8932 7.20546 11.0894 7.33285 11.2734 7.45117L15.9941 10.4863C16.152 10.5878 16.3288 10.7002 16.4678 10.8086C16.6072 10.9174 16.8273 11.109 16.957 11.416C17.1147 11.7893 17.1147 12.2107 16.957 12.584C16.8273 12.891 16.6072 13.0826 16.4678 13.1914C16.3288 13.2998 16.152 13.4122 15.9941 13.5137L11.2734 16.5488C11.0894 16.6672 10.8932 16.7945 10.7217 16.8838C10.558 16.969 10.2611 17.1062 9.89355 17.0801C9.45955 17.0491 9.05959 16.8317 8.79883 16.4834C8.57779 16.1881 8.53346 15.8635 8.5166 15.6797C8.49896 15.4873 8.5 15.2538 8.5 15.0352V8.96582C8.5 8.74701 8.49895 8.51282 8.5166 8.32031C8.53346 8.13652 8.57779 7.81186 8.79883 7.5166C9.05959 7.16829 9.45956 6.95092 9.89355 6.91992L10.0273 6.91699ZM10.5 14.667L14.6504 12L10.5 9.33203V14.667ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as PlayCircleIcon };
